import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Engineering Management For The Rest Of Us"
        desc="The Playbook for every new Engineering Manager, written by Sarah Drasner"
        image="/images/books/engineering-management-for-the-rest-of-us.jpg"
        pageType="book"
        author="Sarah Drasner"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/engineering-management-for-the-rest-of-us.jpg"
                width="400"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Engineering Management for the rest of Us
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Sarah Drasner</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                This book is a great overview of the Engineering Manager role in big companies. It covers the essentials of a lot of topics, but it does not go deep into any of them. If you are an
                engineering manager or a leader with some experience, this book probably is not for you.
              </p>
              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-10">
                <strong>About Sarah Drasner</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Sarah is Director of Engineering at Google
              </p>

              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-12">
                <strong>A book suggested for</strong>
              </h2>
              <Item
                title=""
                description="For new managers without experience or specific training, this book will be your playbook for your first 90 days."
              />
              <Item
                title=""
                description="For ICs who are considering to become managers but they are not decided yet."
              />
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
